import {HttpContextToken} from '@angular/common/http';

/**
 * Token per indicare se una richiesta deve essere "silenziosa" in caso di errore.
 * Se impostato a true, l'interceptor restituirà un successo vuoto invece di propagare l'errore.
 */
export const IS_SILENT_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * Token per definire il valore di default da restituire in caso di errore silenzioso.
 */
export const SILENT_ERROR_DEFAULT_VALUE = new HttpContextToken<any>(() => ({res: null}));

/**
 * Chiede all'interceptor di **propagare** l'errore invece di silenziarlo.
 *
 * Serve perché il silenziamento non è solo su richiesta: ogni GET non di
 * autenticazione viene silenziata d'ufficio, per rendere l'applicazione
 * tollerante ai guasti dei servizi che alimentano una schermata. Quella
 * scelta però non regge dove l'esito della GET *è* la risposta a un gesto
 * dell'utente — scaricare un documento, aprirlo — e i vari modi in cui può
 * fallire vanno distinti fra loro: lì un finto 200 con corpo vuoto
 * trasformerebbe un messaggio preciso in un guasto incomprensibile.
 *
 * Ha la precedenza su {@link IS_SILENT_ERROR} e sul silenziamento automatico.
 */
export const PROPAGA_ERRORE = new HttpContextToken<boolean>(() => false);
